<template>
  <main class="main cart-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="title weight-600">{{ $t("My Cart") }}</div>
            </div>
            <div class="button bordered small" @click="$parent.emptyCart">
              {{ $t("Clear cart") }}
            </div>
          </div>
        </div>
      </div>
      <section class="section cart-section">
        <div class="wrapper">
          <div class="title empty-desc" v-if="!$parent.cartContents.length">
            {{ $t("Cart is empty!") }}
          </div>
          <div class="left" v-if="$parent.cartContents.length">
            <div class="total-block">
              <div class="total">
                <div class="desc medium">
                  <b>{{ $t("Total:") }}</b>
                </div>
                <div class="title">
                  <b>
                    {{ $parent.totalSum }}
                    <span class="currency text-blue">{{
                      $parent.currency
                    }}</span>
                  </b>
                </div>
              </div>
              <div class="cta-container">
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input type="checkbox" name="terms" v-model="terms" />
                      <div class="checkbox"></div>
                      <span class="desc">{{ $t("I agree with") }} </span>
                      <a @click="$parent.goToPage('terms')" class="desc orange">
                        {{ $t("T&Cs") }}</a
                      >
                      <span class="desc"> {{ $t("and") }} </span>
                      <a
                        @click="$parent.goToPage('privacy')"
                        class="desc orange"
                      >
                        {{ $t("Privacy Policy") }}</a
                      >
                    </div>
                  </label>
                </div>
              </div>
              <button
                :class="['button', { disabled: !requiredFieldsAreFilled }]"
                @click="submit"
              >
                <span>{{ $t("COMPLETE ORDER") }}</span>
              </button>

              <label>
                <div class="desc">{{ $t("Promocode") }}:</div>
                <input
                  v-model="promo"
                  type="text"
                  :placeholder="$t('Promocode')"
                />
                <button class="button" @click="applyPrompo">
                  {{ $t("Apply") }}
                </button>
              </label>
              <transition name="slide">
                <div v-if="promoError" class="error-desc desc red">
                  {{ promoError }}
                </div>
              </transition>
              <transition name="slide">
                <div v-if="$parent.error" class="error-desc desc red">
                  {{ $parent.error }}
                </div>
              </transition>
            </div>
          </div>
          <div class="right">
            <div class="title small weight-600 title-main">
              {{ $t("Items") }}
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, i) in $parent.cartContents"
                :key="i"
              >
                <div class="preview-container">
                  <div class="preview">
                    <img :src="imgDomain + item.item.img_url" class="img" />
                  </div>
                  <div class="desc small name">
                    <b>{{ item.item.title }}</b>
                  </div>
                </div>
                <div class="price-container">
                  <div class="price desc small">
                    <b>
                      {{ item.item.price }}
                      <span class="currency text-blue">{{
                        $parent.currency
                      }}</span>
                    </b>
                  </div>
                  <div class="delete" @click="removeItem(item)">
                    <img src="./../img/bin.svg" class="img" />
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="title small weight-600 title-main">
              {{ $t("Payment details:") }}
            </div>
            <div class="wrapper">
              <div class="form">
                <label class="payment-method">
                  <div class="desc">{{ $t("Payment method") }}</div>
                  <input
                    type="text"
                    readonly
                    :value="$t('Credit/Debit card')"
                  />
                  <div class="list">
                    <img src="./../img/methods/visa.svg" class="visa" />
                    <img src="./../img/methods/mc.svg" class="mc" />
                  </div>
                </label>
              </div>
            </div> -->
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import useCurrency from "../utils/useCurrency";

export default {
  name: "Cart",
  props: [],
  components: {},
  data: function () {
    return {
      imgDomain: "",
      email: "",
      phone: "",
      nickname: "",
      country: "",
      countryId: "",
      countryOptions: "",
      city: "",
      address: "",
      zipCode: "",
      terms: false,
      currency: "",
      promo: "",
      promoError: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getProfile();
    this.getCounties();
    // Sync currency from composable
    const currencyComposable = useCurrency();
    this.currency = currencyComposable.getCurrencyCode();
    currencyComposable.onCurrencyChange(() => {
      this.currency = currencyComposable.getCurrencyCode();
    });
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (this.terms) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  watch: {
    currency(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$parent.getCartContents();
      }
    },
    country: function () {
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.country === this.countryOptions[i].title) {
          this.countryId = this.countryOptions[i].id;
          break;
        }
      }
      this.countryId;
    },
  },
  methods: {
    applyPrompo() {
      let self = this;
      self.promoError = "Specified code is not valid";
      setTimeout(function () {
        self.promoError = "";
      }, 3000);
    },
    removeItem(item) {
      this.$parent.removeFromCart(
        {
          ...item.item,
          type: item.type,
        },
        item.item_id
      );
    },
    submit() {
      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        email: this.email,
        nickname: this.nickname,
      };
      this.$emit("orderSubmit", data);
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch(() => {});
    },
    getProfile() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.email = res.data.email;
          this.nickname = res.data.nickname;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
  },
};
</script>
